"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Immersive3DModelReferenceSchema = void 0;
exports.Immersive3DModelReferenceSchema = {
    "$id": "https://www.redbull.com/schemas/reference/content/immersive-3d-models.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "Immersive3DModelReference",
    "description": "An immersive 3D experience to be experienced on compatible devices.",
    "type": "object",
    "required": [
        "type",
        "id"
    ],
    "properties": {
        "type": {
            "enum": [
                "rrn:master:immersive-3d-models"
            ],
            "type": "string"
        },
        "id": {
            "type": "string",
            "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}$"
        }
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW1tZXJzaXZlLTNkLW1vZGVscy5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9yZWZlcmVuY2UvY29udGVudC9pbW1lcnNpdmUtM2QtbW9kZWxzLnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLCtCQUErQixHQUFHO0lBQzdDLEtBQUssRUFBRSxtRkFBbUY7SUFDMUYsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsMkJBQTJCO0lBQ3BDLGFBQWEsRUFBRSxxRUFBcUU7SUFDcEYsTUFBTSxFQUFFLFFBQVE7SUFDaEIsVUFBVSxFQUFFO1FBQ1YsTUFBTTtRQUNOLElBQUk7S0FDTDtJQUNELFlBQVksRUFBRTtRQUNaLE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRTtnQkFDTixnQ0FBZ0M7YUFDakM7WUFDRCxNQUFNLEVBQUUsUUFBUTtTQUNqQjtRQUNELElBQUksRUFBRTtZQUNKLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLFNBQVMsRUFBRSw2RUFBNkU7U0FDekY7S0FDRjtDQUNGLENBQUEifQ==